// Generated by CoffeeScript 2.7.0
require('./mixins/index.js');

require('./directives/index.js');

require('./components/index.js');

Vue.prototype.Skylark = Skylark;

Vue.prototype.Deprecation = Deprecation;
